import React from 'react';
import moment from 'moment';
import { TableBody, TableCell, TableHead, TableHeadCell } from 'src/components/MainTable/MainTable.style';
import { observer } from 'src/utils/mobx-react';
import {
    HeaderItem,
    HeaderText,
    HeaderTitle,
    HeaderWrapper,
    MainTableRowWrapper,
    MainTableHeadRowWrapper,
} from './AutomaticWithdrawalHistory.style';
import { NetDeposit } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/CommonParts/WithdrawalHistory/WithdrawalHistory/NetDeposit';
import { SmallerItemRow } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/CommonParts/GridRow.style';
import { Amount } from 'src_common/common/amount/Amount';
import { AutoWithdrawalHistoryResponseLKType } from 'src/api/config/automaticWithdrawal/getWithdrawalHistoryLK';
import { StaffAccountWalletDataType } from 'src/AppState/sdk/staff';
import { NetDepositState } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/CommonParts/WithdrawalHistory/WithdrawalHistory';

type AutomaticWithdrawalHistoryPropsType = {
    customerId: number;
    history: null | AutoWithdrawalHistoryResponseLKType;
    netDepositState: NetDepositState;
    walletDataLocal: StaffAccountWalletDataType | null;
};

export const AutomaticWithdrawalHistory = observer(
    'AutomaticWithdrawalHistory',
    (props: AutomaticWithdrawalHistoryPropsType) => {
        const { customerId, history, netDepositState, walletDataLocal } = props;

        if (walletDataLocal === null || history === null) {
            return null;
        }

        const { currency, createdAt } = walletDataLocal;

        const registrationDate = moment(createdAt).format('YYYY-MM-DD');

        const renderTable = (): React.ReactNode => {
            return history.map((item, index) => {
                const amount = new Amount(item.amount ?? '0');
                const parsedAmount = amount.div(100);

                return (
                    <MainTableRowWrapper key={`${item.date}-${index}`}>
                        <SmallerItemRow> {item.card} **** **** **** </SmallerItemRow>
                        <TableCell key={`${item.date}${item.ruleType}${index}`}>{item.ruleType}</TableCell>
                        <TableCell key={`${item.date}${item.actionedBy}${index}`}>
                            {item.actionedBy.length === 0 ? '-' : item.actionedBy}
                        </TableCell>
                        <TableCell key={`${item.date}${item.date}`}>{moment(item.date).format('DD/MM/YYYY')}</TableCell>
                        <TableCell key={`${item.date}${item.reason?.[0] ?? ''}`}>
                            {item.reason?.length === 0 ? '-' : item.reason?.toString()}
                        </TableCell>
                        <TableCell key={`${item.date}${parsedAmount.value}`}>{parsedAmount.format(currency)}</TableCell>
                        <TableCell>{item.note.length === 0 ? '-' : item.note}</TableCell>
                    </MainTableRowWrapper>
                );
            });
        };

        return (
            <section>
                <HeaderWrapper>
                    <HeaderItem>
                        <HeaderTitle>Account Number:</HeaderTitle>
                        <HeaderText>{customerId}</HeaderText>
                    </HeaderItem>
                    <HeaderItem>
                        <HeaderTitle>KYC Passed:</HeaderTitle>
                        <HeaderText>N/D</HeaderText>
                    </HeaderItem>
                    <HeaderItem>
                        <HeaderTitle>Registered:</HeaderTitle>
                        <HeaderText>{registrationDate}</HeaderText>
                    </HeaderItem>
                </HeaderWrapper>

                <div>
                    <TableHead>
                        <MainTableHeadRowWrapper>
                            <TableHeadCell>Card</TableHeadCell>
                            <TableHeadCell>Status</TableHeadCell>
                            <TableHeadCell>Actioned By</TableHeadCell>
                            <TableHeadCell>Date</TableHeadCell>
                            <TableHeadCell>Reason</TableHeadCell>
                            <TableHeadCell>Amount</TableHeadCell>
                            <TableHeadCell>Notes</TableHeadCell>
                        </MainTableHeadRowWrapper>
                    </TableHead>
                    <TableBody>{renderTable()}</TableBody>
                </div>

                <NetDeposit
                    currency={currency}
                    netDepositState={netDepositState}
                    isCustomerTab={false}
                />
            </section>
        );
    }
);
